/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Twda_SyncInputs */



/**
* | output |
* | --- |
* | "TWDA sync" |
*
* @param {Admin_Status_Twda_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_twda_sync = /** @type {((inputs?: Admin_Status_Twda_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Twda_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation TWDA")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización TWDA")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronização TWDA")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione TWDA")
	return /** @type {LocalizedString} */ ("TWDA sync")
});